import Cookies from 'universal-cookie'

const cookies = new Cookies()

export const LOGIN_TOKEN = 'login_token'

const setItem = (value: string) => {
  cookies.set(LOGIN_TOKEN, value, { secure: true })
}

const getItem = () => {
  const results = cookies.get(LOGIN_TOKEN)

  if (!results) {
    return null
  }

  return results
}

const removeItem = () => {
  return cookies.remove(LOGIN_TOKEN)
}

const getToken = () => {
  const user = getItem()
  if (!user) {
    return undefined
  }

  return user
}

const isLogged = !!getToken()

export { setItem, getItem, removeItem, getToken, isLogged }
